import { render, staticRenderFns } from "./approval-leave.vue?vue&type=template&id=79796c96&scoped=true"
import script from "./approval-leave.vue?vue&type=script&lang=js"
export * from "./approval-leave.vue?vue&type=script&lang=js"
import style0 from "./approval-leave.vue?vue&type=style&index=0&id=79796c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79796c96",
  null
  
)

export default component.exports